import React from 'react';
import { getEnviroment } from "../../../lib/utils.es6";

const STAGING_BASE_URL = "https://ipp-samba.staging.aspin-inclusivity.com";
const PRODUCTION_BASE_URL = "https://ipp-samba.inclusivity-aspin.com";

class PolicyAmend extends React.Component {
  render() {
    const source = "aspin";
    const environment = getEnviroment();
    // REACT_APP_IPP_SAMBA_BASE_URL overrides the embeddable origin for local
    // development (e.g. http://localhost:3001 running ipp-samba)
    const baseUrl =
      process.env.REACT_APP_IPP_SAMBA_BASE_URL ||
      (environment === "prod" ? PRODUCTION_BASE_URL : STAGING_BASE_URL);
    const host_base_url = window.location.origin;
    // Support both route param (/amend-policy/:policy_number) and query param (?policy_number=...)
    const policyNumber =
      (this.props.params && this.props.params.policy_number) ||
      (this.props.location && this.props.location.query && this.props.location.query.policy_number);

    const iframeSrc = `${baseUrl}/?partner=moovance&journey=amend&source=${encodeURIComponent(source)}&environment=${encodeURIComponent(environment)}&host_base_url=${encodeURIComponent(host_base_url)}${policyNumber ? '&policy_number=' + encodeURIComponent(policyNumber) : ''}`;

    return (
      <>
        <section
          style={{
            background: "#FFFFFF",
            borderRadius: "8px",
            height: "auto",
            marginTop: "30px",
            marginBottom: "30px",
            width: "100%",
          }}
        >
          <iframe
            src={iframeSrc}
            width="100%"
            height="100%"
            style={{
              width: "100%",
              height: "calc(100vh - 100px)",
              border: "none",
            }}
            title="Amend Policy"
          ></iframe>
        </section>
      </>
    );
  }
}

export default PolicyAmend;
